import React from 'react';

interface BlogPreviewProps {
  title: string;
  content: string;
  author: string;
  category: string;
  tags: string[];
  readTime: number;
  imageUrl?: string;
  onClose: () => void;
}

const BlogPreview: React.FC<BlogPreviewProps> = ({
  title,
  content,
  author,
  category,
  tags,
  readTime,
  imageUrl,
  onClose
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-lg max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-4 border-b border-gray-700">
          <h2 className="text-xl font-semibold text-white">📄 Попередній перегляд статті</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white text-2xl"
          >
            ×
          </button>
        </div>
        
        <div className="flex-1 overflow-y-auto p-6">
          <article className="prose prose-invert max-w-none">
            {/* Article Header */}
            <div className="mb-6">
              <div className="flex items-center space-x-4 mb-4 text-sm text-gray-400">
                <span className="bg-blue-600 text-white px-2 py-1 rounded text-xs">
                  {category}
                </span>
                <span>📖 {readTime} хв читання</span>
                <span>✍️ {author}</span>
              </div>
              
              <h1 className="text-3xl font-bold text-white mb-4 leading-tight">
                {title || 'Назва статті'}
              </h1>
              
              {tags.length > 0 && (
                <div className="flex flex-wrap gap-2 mb-4">
                  {tags.map((tag, index) => (
                    <span
                      key={index}
                      className="bg-gray-700 text-gray-300 px-2 py-1 rounded-full text-xs"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>
              )}
            </div>

            {/* Article Image */}
            {imageUrl && (
              <div className="mb-6">
                <img
                  src={imageUrl}
                  alt={title}
                  className="w-full h-64 object-cover rounded-lg"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                  }}
                />
              </div>
            )}

            {/* Article Content */}
            <div 
              className="text-gray-300 leading-relaxed"
              dangerouslySetInnerHTML={{ 
                __html: content || '<p className="text-gray-500 italic">Контент статті буде тут...</p>' 
              }}
            />
          </article>
        </div>
        
        <div className="p-4 border-t border-gray-700 flex justify-end">
          <button
            onClick={onClose}
            className="px-6 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors"
          >
            Закрити попередній перегляд
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogPreview;
